export default __webpack_public_path__ + "static/media/gold.c0aaa125.svg";